import React, { createContext, useEffect, useMemo } from 'react';
import Tracking from 'libs/tracking';
import Cookies from 'cookies';
import { COOKIES } from 'libs/constants';
import MD5 from 'crypto-js/md5';
import dayjs from 'dayjs';
import Home from './Home';

export const HomePageContext = createContext({
  keenTempUid: ''
});

function HomePage({ keenTempUid }) {
  const homePageProps = useMemo(() => ({ keenTempUid }), [keenTempUid]);
  useEffect(() => {
    Tracking.track('Home Page Viewed', {}, true);
  }, []);
  return (
    <HomePageContext.Provider value={homePageProps}>
      <Home />
    </HomePageContext.Provider>
  );
}

const createGuid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

const getKeenUid = (keenUidCookie: string): string =>
  keenUidCookie.substring(
    keenUidCookie.indexOf('=') + 1,
    keenUidCookie.indexOf('&')
  );

export async function getServerSideProps({ req, res }) {
  let keenTempUid = '';
  const cookies = new Cookies(req, res);
  const siftSessionId = cookies.get(COOKIES.siftSessionId);
  if (!siftSessionId) {
    const date = new Date();
    date.setDate(date.getDate() + 90);
    cookies.set(COOKIES.siftSessionId, createGuid(), {
      expires: date,
      httpOnly: false
    });
  }
  const keenUidCookie = cookies.get(COOKIES.keenUid);
  if (keenUidCookie)
    keenTempUid = decodeURIComponent(getKeenUid(keenUidCookie)).substring(
      0,
      25
    );
  else {
    const guid = createGuid();
    const md5Hash = MD5(guid).toString().substring(0, 25);
    const dateTimeString = dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss a');
    const forwarded = req.headers['x-forwarded-for'];
    const ipAddress =
      typeof forwarded === 'string'
        ? forwarded.split(/, /)[0]
        : req.socket.remoteAddress;
    let cookieVal = `Uid=${md5Hash}&firstVisitTime=${dateTimeString.toUpperCase()}&ipAddress=${ipAddress}`;
    cookieVal = encodeURI(cookieVal);
    cookies.set(COOKIES.keenUid, cookieVal);
    keenTempUid = getKeenUid(cookieVal);
  }
  return {
    props: {
      keenTempUid
    }
  };
}

export default HomePage;
